var ajaxExecuted = false;
var btnContactNow = document.getElementsByClassName("btn-contact-now");

function handleContactClick(e) {
  e.preventDefault();

  if (!ajaxExecuted) {
    var $form = $("#contact-form");
    var contactForm = document.getElementById("contact-form");
    const formData = new FormData(contactForm);
    const data = {};

    function checkRequiredFields() {
      var missingFields = [];
      var emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

      $form.find('[required="required"]').each(function () {
        var $input = $(this);
        var fieldName = $input.attr("name");

        if ($input.is(":checkbox")) {
          // Für Checkboxen das zugehörige Label überprüfen
          var $label = $('label[for="' + $input.attr("id") + '"]');
          if (!$input.prop("checked")) {
            missingFields.push(fieldName);
            $input.addClass("error-field");
            $label.addClass("error-field");
          } else {
            $input.removeClass("error-field");
            $label.removeClass("error-field");
          }
        } else if ($input.is("select")) {
          // Für Select-Boxen das zugehörige Label überprüfen
          var $label = $('label[for="' + $input.attr("id") + '"]');
          if ($input.val() === "") {
            missingFields.push(fieldName);
            $input.addClass("error-field");
            $label.addClass("error-field");
          } else {
            $input.removeClass("error-field");
            $label.removeClass("error-field");
          }
        } else {
          if ($input.val() === "") {
            allFieldsFilled = false;
            missingFields.push(fieldName);
            $input.addClass("error-field");
          } else {
            $input.removeClass("error-field");
          }

          // E-Mail-Feld Validierung
          if (fieldName === "email" && !emailRegex.test($input.val())) {
            missingFields.push(fieldName);
            $input.addClass("error-field");
          }
        }
      });

      if (missingFields.length > 0) {
        var errorMessage =
          "Folgende Felder fehlen oder sind ungültig: " +
          missingFields.join(", ");
        alert(errorMessage);
      }

      return missingFields.length === 0;
    }

    if (checkRequiredFields()) {
      formData.forEach((value, key) => {
        if (key === "items") {
          try {
            data[key] = JSON.parse(value);
          } catch (error) {
            data[key] = value;
          }
        } else {
          data[key] = value;
        }
      });

      const jsonData = JSON.stringify(data);
      ajaxExecuted = true;
      $.ajax({
        type: "POST",
        url: "https://" + host + "/api.php?api=submitForm",
        data: jsonData,
        xhrFields: {
          withCredentials: false,
        },
        headers: {},
        success: function () {
          console.log("Success");
          $("#m-contact-confirmation").modal({
            backdrop: "static",
            keyboard: false,
            show: true,
          });
        },
        error: function () {
          console.error("Das Senden hat leider nicht geklappt");
        },
        complete: function () {
          ajaxExecuted = false;
        },
      });
    } else {
    }
  }
}

for (var i = 0; i < btnContactNow.length; i++) {
  btnContactNow[i].addEventListener("click", handleContactClick);
}

$(document).ready(function () {
  // Cache references to the form and submit button
  var $form = $("#contact-form");
  var $submitButton = $form.find('input[type="submit"]');

  function markRequiredFields() {
    var missingFields = [];

    $form.find('input[required="required"]').each(function () {
      if ($(this).val() === "") {
        allFieldsFilled = false;
        missingFields.push($(this).attr("name"));
        //nur markieren bei versendeversuch, aber entmarkieren bei ausfüllen
        //$(this).addClass("error-field"); // Hinzufügen der CSS-Klasse bei fehlenden Feldern
      } else {
        $(this).removeClass("error-field"); // Entfernen der CSS-Klasse bei ausgefüllten Feldern
      }
    });

    return missingFields.length === 0;
  }

  // Initial state of the submit button
  $submitButton.prop("disabled", !markRequiredFields());

  // Listen for input events on required fields
  $form.on("input", 'input[required="required"]', function () {
    $submitButton.prop("disabled", !markRequiredFields());
  });
});
